export default {
    list: {
        title: 'Zones',
        empty: 'No zones',
        search: 'Search zones…'
    },
    fields: {
        name: 'Name',
        validSince: 'Valid since (min)',
        validUntil: 'Valid until (min)',
        slots: 'Slots',
        noSlots: 'No slots'
    },
    qr: {
        title: 'Configuration QR for zone',
        addToClipboard: 'Add to clipboard',
        added: 'Added to clipboard'
    }
}
